import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-accounts',
    template: '<p>accounts works!</p>',
    standalone: false
})
export class AccountsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
